function c({
  collapseBelow: l,
  reverseOnCollapse: e
}) {
  const [o, n] = r(
    l
  );
  return {
    flexDirection: [
      t(o, e),
      t(n, e),
      "row"
    ],
    collapseOnMobile: o,
    collapseOnTablet: n
  };
}
function t(l, e) {
  return l ? e ? "column-reverse" : "column" : "row";
}
function r(l) {
  const e = l === "desktop";
  return [e || l === "tablet", e];
}
export {
  c as resolveCollapsibleProps
};
